import { api } from '@/api/client'
import type { Cart } from '@/api/orders'
import type { ProductUnit } from '@/api/suppliers'

export interface TemplateItem {
  id: string
  supplierId: string
  supplierName: string
  businessItemId: string | null
  name: string
  unit: ProductUnit
  quantity: string
  note: string | null
  sortOrder: number
}

export interface OrderTemplate {
  id: string
  name: string
  itemCount: number
  supplierCount: number
  createdAt: string
  items: TemplateItem[]
}

export interface SupplierStat {
  supplierId: string
  supplierName: string
  orderCount: number
  itemCount: number
  lastOrderAt: string | null
}

export interface MonthStat {
  month: string
  orderCount: number
  itemCount: number
}

export interface Statistics {
  fromDate: string
  toDate: string
  totalOrders: number
  totalItems: number
  bySupplier: SupplierStat[]
  byMonth: MonthStat[]
  byStatus: { status: string; orderCount: number }[]
}

/** Πρόγραμμα που γεμίζει μόνο του το καλάθι. Δεν στέλνει παραγγελία. */
export interface RecurringOrder {
  id: string
  templateId: string
  templateName: string
  weekdays: number[]
  runAt: string
  isActive: boolean
  lastRunAt: string | null
  nextRunDate: string | null
}

export const recurringApi = {
  list: () => api.get<RecurringOrder[]>('/recurring-orders'),
  create: (payload: { templateId: string; weekdays: number[]; runAt: string }) =>
    api.post<RecurringOrder>('/recurring-orders', payload),
  update: (
    id: string,
    payload: { weekdays?: number[]; runAt?: string; isActive?: boolean },
  ) => api.patch<RecurringOrder>(`/recurring-orders/${id}`, payload),
  remove: (id: string) => api.delete<void>(`/recurring-orders/${id}`),
}

export const templatesApi = {
  list: () => api.get<OrderTemplate[]>('/templates'),
  get: (id: string) => api.get<OrderTemplate>(`/templates/${id}`),
  fromCart: (name: string) => api.post<OrderTemplate>('/templates/from-cart', { name }),
  rename: (id: string, name: string) => api.patch<OrderTemplate>(`/templates/${id}`, { name }),
  remove: (id: string) => api.delete<void>(`/templates/${id}`),
  loadIntoCart: (id: string) => api.post<Cart>(`/cart/load-template/${id}`),
}

export const statisticsApi = {
  get: () => api.get<Statistics>('/statistics'),
}
